import {useCallback, useEffect, useState} from 'react';

import {getIssues, transformIssues} from '../../utils/githubHelpers';

import type {TransformedIssue} from '../../utils/githubHelpers';

/**
 * UseIssues.
 *
 * @param storyId The story id.
 * @param update  Triggers an update.
 * @param active  If the hook is active.
 * @returns The state.
 */
export const useIssues = (storyId: string, update: number, active: boolean) => {
    const [state, setState] = useState<TransformedIssue[]>([]);
    const [error, setError] = useState<string | null>(null);

    const loadIssues = useCallback(async () => {
        const issues = await getIssues(storyId);

        if (issues !== null) {
            const transformedIssues = await transformIssues(issues);

            setError(null);
            setState(transformedIssues);

            return;
        }

        setError('Something went wrong.');
    }, [storyId]);

    useEffect(() => {
        if (active) {
            void loadIssues();
        }
    }, [active, update, loadIssues]);

    return {
        error,
        issues: state
    };
};